var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "calc-range range control",
      attrs: { "data-field": _vm.externalKey }
    },
    [
      _vm.label
        ? _c("label", { staticClass: "range__label" }, [
            _vm._v(
              "\n    " + _vm._s(_vm.label) + _vm._s(_vm.measureUnit) + "\n  "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("control-text", {
        attrs: {
          "is-disabled": _vm.inputDisabled,
          "default-value": _vm.value,
          "default-display-value": _vm.monthToYearsValue,
          "external-handler": _vm.inputHandler,
          "external-change-handler": _vm.changeInputHandler,
          "external-key": _vm.inputExternalKey
        }
      }),
      _vm._v(" "),
      _c("div", {
        ref: "slider",
        staticClass: "range__slider",
        attrs: { id: "range-slider" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }